<template>
    <div>
        <!-- 手机浏览器的下载行为，需要把资源一个一个的罗列出来进行下载 -->
        <el-popover v-if="isH5PhoneAgent"
                    placement="top"
                    width="260"
                    trigger="manual"
                    v-model="visible">
            <!-- pop over 的内容 -->
            <!-- 标题 -->
            <el-row type="flex" justify="center" align="middle" style="line-height: 36px">
                <el-col :span="21" style="font-size:12px;">资源</el-col>
                <el-col :span="3" style="font-size:20px; color:#C0C4CC"><i class="el-icon-close" @click="visible=false" /></el-col>
            </el-row>
            <!-- 内容 -->
            <div v-if="isSignIn" v-for="name in resources">
                <el-row align="middle" style="font-size:14px; line-height: 40px">
                    <el-col :span="20">{{name}}</el-col>
                    <!--
                    注意事项如下
                    1. 经历过使用 Stream/Blob + Axios 的方式，但是发现它们都必须将文件全部下载到内存后才能保存。还是发现 a download 的方式最稳妥！但是，这种方式最大的弊端就是将用户的 token 直接暴露到了 URL 链接上！
                    2. 使用 target blank 的目的是，如果出现未授权出现链接的情况，点击下载后跳转到新的页面显示 403 错误。但是如果按照正常的页面流程是不会到这一步的。
                       deprecated! 最后还是停用了这种做法，因为弹出一个新的窗口非常影响用户体验！并且如果按照正常使用操作逻辑，是不会到 403 这一步的。
                    -->
                    <el-col :span="4"><a :href="getResourceUrlWithToken(name) " download>下载</a></el-col>
                    <!-- <el-col :span="4"><el-link :underline="false" @click="h5Download(name)">下载</el-link></el-col>-->
                </el-row>
            </div>
            <!-- pop over 的内容结束 -->
            <iconfont-selector-tooltip slot="reference"
                                       :handler="download"
                                       :is-actived="true"
                                       default-class="el-icon-download"
                                       actived-class="el-icon-download"
                                       default-color="#2c3e50"
                                       actived-color="#2c3e50"
                                       :font-size="30"
                                       :line-height="30"
                                       tooltip-text="下载"/>
        </el-popover>
        <!-- Hybrid html5plus and PC client 下载的行为 -->
        <iconfont-selector-tooltip v-else
                                   slot="reference"
                                   :is-actived="true"
                                   default-class="el-icon-download"
                                   actived-class="el-icon-download"
                                   default-color="#2c3e50"
                                   actived-color="#2c3e50"
                                   :font-size="30"
                                   :line-height="30"
                                   :handler="download"
                                   tooltip-text="下载"/>
        <!-- <div style="font-size: 12px;line-height:16px;">{{text}}</div>-->
        <div style="font-size: 12px;line-height:16px;">下载</div>
        <payment ref="payment" :shortcode="e.shortcode" @ispaid="checkPaid"></payment>
    </div>
</template>

<script>
    import Payment from "../commons/Payment";
    const assert = require('assert');
    const path = require('path');
    import env from '../../../config/env';
    import { isHtml5PlusSupported, isPhoneAgent, isWebAgent, successMessage, warningMessage, errorMessage, User, GlobalLoading } from "../../utils";
    import { isDownloadable } from "../../data/download";

    let FileSaver = require('file-saver');

    export default {
        name: "EntityDownload",
        components: {Payment},
        props: {
            e: null
        },
        data: function(){
            return {
                visible: false,
                baseUrl: env.BACKEND_BASE_URL(),
                repaint: false,
                resources: [],
                text: '...'
            }
        },
        computed: {
            isH5PhoneAgent() {
                return isPhoneAgent() && !this.isHybridAgent;
            },
            isHybridAgent() {
                return isHtml5PlusSupported();
            },
            isSignIn(){
                return this.$store.getters.getUser() !== null;
            }
        },
        mounted(){
            this.$EventBus.$on('signedin', () => {
                console.log('Favorite, caught the signedin global event');
                this.isDownloadable_(); // 赋值 text
            });
            this.$EventBus.$on('signout', () => {
                console.log('Favorite, caught the signout global event');
                this.isDownloadable_(); // 赋值 text
            });
        },
        beforeDestroy() {
            // 说是（https://juejin.cn/post/6861572888420581390），在该组件被销毁的时候，需要移除该组件对该事件的监听。
            this.$EventBus.$off('signedin');
            this.$EventBus.$off('signout');
        },
        created() {
            console.log('entity download created');
            // 初始化 resources.
            for(let r of this.e.slots){
                if (r.video !== undefined ){
                    this.resources.push(path.basename(r.video));
                }else{
                    this.resources.push(path.basename(r.pic));
                }
            }
            console.log(`entity download, ${this.e.shortcode}, the resources parsed as ${this.resources}`);
            // 赋值 text
            this.isDownloadable_();
        },
        methods: {

            token() {
                return User.token;
            },

            /**
             *
             * @param name, the resource name
             */
            getResourceUrl(name){
                return this.baseUrl + '/d/' + this.e.shortcode + '/' + name;
            },

            getResourceUrlWithToken(name){
                let url = this.getResourceUrl(name);
                url += User.token !== null ? '?token=' + User.token : '';
                return url;
            },

            // 注意，现在匿名用户只是没有注册信息，是有临时 usercode 的，因此都是登录用户，只是一个是匿名一个是注册的区别了。
            async isDownloadable_(){
                let downloadable = await isDownloadable(this.e.shortcode);
                this.text = downloadable ? '已购' : '￥'+this.e.price;
                return downloadable;
            },

            download() {
                let anchor = document.createElement('a');
                anchor.href = `${env.BACKEND_BASE_URL()}/d/app`;
                anchor.target="_blank";
                anchor.click();
            },

            /**
             * 下载事件发生的公共入口事件 - The Entrance Download。
             * 下面是下载流程的简述，
             * 1. 首先，判断该资源用户是否已经购买且是否在有效期内？如果有效，则直接发起下载。若无效（或者没有购买过）则弹出购买窗口。购买成功
             *    后回调 checkPaid 方法进行后续的下载动作。
             * 2. 然后，再根据不同客户端实施不同的下载方案进行下载。
             * TODO 如果没有购买发起购买支付接口。
             * TODO 不允许断网的时候触发
             * @deprecated 现在直接跳转到 app 的下载通道
             */
            download_backup(){
                GlobalLoading.start();
                // 这里给个 Timeout 的目的是，因为 loading 的旋转启动是个比较耗费资源的操作，让它启动后在执行其他操作，否则 spinner 会异常。
                setTimeout(()=>{
                    (async()=>{
                        try{
                            // 检查用户是否已经购买，且在有效期内；之前有想过既然在 created() 中已经调用过这个方法是否可以缓存避免重复调用，但是想了想，因为这是支付环节，每一步都很重要，为了保证幂等，因此还是重复调用一次。
                            let downloadable = await this.isDownloadable_(this.e.shortcode);
                            // GlobalLoading.stop();
                            if( !downloadable ){
                                console.log(`entity download, ${this.e.shortcode} is not downloadable, start to payment`);
                                this.$refs.payment.start();
                            } else {
                                console.log(`entity download, ${this.e.shortcode} is downloadable, start to download`);
                                this.doDownload();
                            }
                        }catch(error){
                            console.error(error);
                        }finally{
                            GlobalLoading.stop();
                        }
                    })();
                },300);
            },

            // payment 支付成功后的回调方法，
            checkPaid(isSuccess){
                if(isSuccess){
                    this.text = '已购'
                    console.log('check paid, paid success, start to download')
                    this.doDownload();
                }else{
                    console.log('check paid, paid failed, stop to download');
                }
            },

            doDownload(){
                console.log('entity download, do download start');
                if ( isWebAgent() ){
                    // 直接使用 FileSaver 下载。
                    this.pcDownload();
                } else if ( this.isH5PhoneAgent ) {
                    this.visible = true;
                } else if ( this.isHybridAgent ){
                    this.h5PlusDownload();
                }
            },

            /**
             * 比较奇怪的特性是，使用 FileSaver 下载的时候，虽然是遍历每次单个下载，但是确实全部一起下载的。
             */
            pcDownload(){
                console.log('entity download, pc download start');
                for(let name of this.resources){
                    let url = this.getResourceUrlWithToken(name);
                    console.log('entity download, pc download, url:', url);
                    FileSaver(url, name);
                }
                successMessage('下载已经开始...');
            },

            /**
             * hybrid html5plus download scenaro,
             * TODO_ add token into header. 试过了，不能直接添加到 h5plus downloader 的 header 中失败
             */
            h5PlusDownload(){
                this.hasFailure = false;
                this.isAlreadyDone = false; // plus.downloader.enumerate 可能同时被回调，导致几个回调方法都检测到已经完成了，因此会弹出几个成功确认窗口，使用该标志位避免
                console.log('entity download, handle download');
                assert.ok(this.isHybridAgent, 'this is the h5plus only download');
                console.log('entity download, html5plus supported, start to download');
                plus.nativeUI.showWaiting('下载中，请稍后...');
                this.tasks = []
                this.failCount = 0;
                for(let name of this.resources){
                    // 无赖之举，本来想的是调用 downloader.setRequestHeader 方法将 token 写入 header 中，结果写入不成功。
                    let resourceUrl = this.getResourceUrlWithToken(name);
                    console.log('the resource url is', resourceUrl);
                    // let this_ = this; // @deprecated, 已经通过 bind 解决了。
                    let task = plus.downloader.createDownload(
                        resourceUrl,
                        { method: 'get', retry: 3, retryInterval: 10 },
                        function( downloaded, status ) { // 下载完成回调
                            if (status == 200) {
                                console.log(`download success and save it as a temp file with filenmae ${downloaded.filename}, and this ${this}`);
                                // 保存到相册方法
                                plus.gallery.save( downloaded.filename,
                                    function () { // 成功
                                        console.log('save into gallery success');
                                        console.log(`this: ${this}`);
                                        this.__downloadingStatusChecking();
                                    }.bind(this),
                                    function () { // 失败
                                        console.error('save into gallery false')
                                        this.__downloadingStatusChecking();
                                        this.hasFailure = true;
                                        this.failCount ++
                                    }.bind(this)
                                );
                            } else {
                                console.error('download fail, status code:', status);
                                errorMessage("下载失败");
                                this.hasFailure = true;
                                this.failCount ++
                                this.__downloadingStatusChecking();
                            }
                        }.bind(this)
                    );
                    // 诡异了，设置 header 无效.....
                    // task.setRequestHeader('Content-Type','application/json');
                    // task.setRequestHeader('Authorization', `Bearer ${User.token}`);
                    this.tasks.push(task);
                }
                plus.downloader.startAll();  // 开始所有的下载任务
            },

            __downloadingStatusChecking(){
                console.log('downloading status checking');
                // 枚举所有正在下载的任务，默认只返回仍然在下载中的任务。
                plus.downloader.enumerate(function(__tasks){
                    console.log("Unfinished task count: " + __tasks.length);
                    if( __tasks.length === 0 && !this.isAlreadyDone){ // 表示所有的任务都已经下载完成
                        this.isAlreadyDone = true;
                        plus.nativeUI.closeWaiting()
                        if( this.hasFailure ){
                            if( this.failCount === this.tasks.length ){
                                plus.nativeUI.alert("资源下载失败，请稍后重试");
                            }else{
                                plus.nativeUI.alert("部分资源下载失败，请重试");
                            }
                        }else{
                            plus.nativeUI.alert("已保存到手机相册");
                        }
                    }
                }.bind(this));
            }

        }
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/entity/EntityDownload.vue